import { ChangeEvent } from 'react';
import { Analyzer, AnalyzerPropertyConstants, SnapshotValidation } from 'types';
import { SnapshotTraceHistoryCombination } from 'features/analyzers/types';

import {
  MenuItem,
  InputLabel,
  Select,
  TextField,
  InputAdornment,
  FormControl,
  FormHelperText,
} from '@mui/material';

import { formatFreqPretty } from 'utils/FreqUtils';

interface Props {
  analyzer: Analyzer | undefined;
  analyzerPropertyConstants: AnalyzerPropertyConstants;
  selectedSnapshot: SnapshotTraceHistoryCombination;
  editedSnapshot: SnapshotTraceHistoryCombination;
  validatedSnapshotProperties: SnapshotValidation | null | undefined;
  validatedPropertyErrors: any;
  editDisabled: boolean;
  disableErrorBox: boolean;
  handleRbwTextInputChange: (rbw: string) => void;
  handleChange: (e: any) => void;
}

const RbwInput = ({
  analyzer,
  analyzerPropertyConstants,
  selectedSnapshot,
  editedSnapshot,
  validatedSnapshotProperties,
  validatedPropertyErrors,
  editDisabled,
  disableErrorBox,
  handleRbwTextInputChange,
  handleChange,
}: Props) => {
  const { type } = analyzer || {};
  const rbwValue = editedSnapshot?.rbw.split(' ')[0] || '';

  const onRbwChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleRbwTextInputChange(`${e.target.value} kHz`);
  };

  //SED Decimator uses an text input instead of a dropdown for RBW values
  if (type === 4) {
    return (
      <TextField
        variant='outlined'
        required
        fullWidth
        id='rbw'
        label='RBW'
        name='rbw'
        autoComplete='rbw_text_input'
        size='small'
        type='number'
        value={Number(rbwValue) <= 0 ? '' : rbwValue}
        onChange={onRbwChange}
        InputProps={{
          endAdornment: <InputAdornment position='end'>kHz</InputAdornment>,
        }}
        disabled={!editedSnapshot?.id || editDisabled}
        error={validatedPropertyErrors.spanError && !disableErrorBox}
        helperText={
          (validatedPropertyErrors.rbwError ||
            selectedSnapshot.rbw === 'AUTO') &&
          validatedSnapshotProperties &&
          formatFreqPretty(validatedSnapshotProperties?.rbw)
        }
      />
    );
  }

  return (
    <FormControl
      variant='outlined'
      size='small'
      error={validatedPropertyErrors.rbwError && !disableErrorBox}
      fullWidth
    >
      <InputLabel id='rbw-label'>RBW</InputLabel>
      <Select
        labelId='rbw-label'
        id='rbw'
        name='rbw'
        label='RBW'
        required
        value={editedSnapshot?.rbw || ''}
        onChange={handleChange}
        disabled={!editedSnapshot?.id || editDisabled}
      >
        {analyzerPropertyConstants?.RBW_VALUES.map((value: string) => (
          <MenuItem value={value} key={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {(validatedPropertyErrors.rbwError ||
          selectedSnapshot.rbw === 'AUTO') &&
          validatedSnapshotProperties &&
          formatFreqPretty(validatedSnapshotProperties?.rbw)}
      </FormHelperText>
    </FormControl>
  );
};

export default RbwInput;
